import React, { useState } from 'react';
import './App.css';
import { signup, availability } from './api';
import { useNavigate } from 'react-router-dom';

export default function SignupModal({ onClose }) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [phone, setPhone] = useState('');
  const [school, setSchool] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    // front-end required-field validation
    if (!userId || !password || !password2 || !phone || !school) {
      setError('모든 항목을 입력해주세요.');
      return;
    }
    if (password !== password2) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }
    setLoading(true);
    try {
      // check availability first
      const availResp = await availability(userId, school);
      if (!availResp.ok) {
        setError('중복확인에 실패했습니다.');
        return;
      }
      const avail = availResp.data || {};
      const problems = [];
      if (avail.user_id === false) problems.push('이미 사용 중인 아이디입니다.');
      if (avail.nickname === false) problems.push('이미 사용 중인 학원명(닉네임)입니다.');
      if (problems.length) {
        setError(problems.join(' '));
        return;
      }
      // all good -> proceed to signup
      const resp = await signup(userId, password, phone, school);
      if (!resp.ok) {
        setError((resp.data && JSON.stringify(resp.data)) || resp.error || '회원가입 실패');
        return;
      }
  window.alert('회원가입이 완료되었습니다.');
  onClose();
  navigate('/');
    } catch (err) {
      setError('서버에 연결할 수 없습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <h2>회원가입</h2>
        <form onSubmit={handleSubmit}>
          <label>아이디
            <input value={userId} onChange={(e)=>setUserId(e.target.value)} required />
          </label>
          <label>비밀번호
            <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required autoComplete="new-password" />
          </label>
          <label>비밀번호 확인
            <input type="password" value={password2} onChange={(e)=>setPassword2(e.target.value)} required autoComplete="new-password" />
          </label>
          <label>전화번호
            <input value={phone} onChange={(e)=>setPhone(e.target.value)} />
          </label>
          <label>학원명
            <input value={school} onChange={(e)=>setSchool(e.target.value)} />
          </label>

          {error && <div className="error">{error}</div>}

          <div style={{display:'flex',justifyContent:'flex-end',marginTop:12}}>
            <button type="button" onClick={onClose} style={{marginRight:8}}>취소</button>
            <button type="submit" className="btn-primary" disabled={loading}>{loading? '로딩...':'가입'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
